export const PACKAGE_CONTENT_KEYS = {
  DISPLAY_NAME: 'PACKAGE_DISPLAY_NAME',
  DESCRIPTION: 'PACKAGE_DESCRIPTION',
  PRINTS_COUNT_OVERRIDE: 'PACKAGE_PRINTS_COUNT_OVERRIDE',
  DIGITAL_COUNT_OVERRIDE: 'PACKAGE_DIGITAL_COUNT_OVERRIDE',
  TAG: 'PKG_TAG',
  TAG_STYLE: 'PKG_TAG_STYLE',
  TAG_PBTF: 'PKG_TAG_PBTF',
  TAG_STYLE_PBTF: 'PKG_TAG_STYLE_PBTF'
} as const;
